<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="19"
    viewBox="0 0 21 19"
    fill="none"
  >
    <path
      d="M5.80875 12.8183C5.5312 12.5295 5.04518 12.4936 4.72795 12.7344L4.71962 12.729L4.0017 13.447C3.84429 13.6039 3.75798 13.8133 3.75798 14.0359C3.74851 14.4843 4.14327 14.8781 4.59114 14.8691C4.85187 14.8733 5.08407 14.7429 5.25413 14.5513L5.80875 13.9967C5.92497 13.8805 6.00294 13.7358 6.03531 13.5784C6.09342 13.3061 6.0075 13.0142 5.80875 12.8183Z"
      fill="currentColor"
    />
    <path
      d="M3.81242 10.3779C3.48745 10.0529 2.9594 10.0532 2.63404 10.3779C2.55842 10.4539 2.09216 10.9199 2.00586 11.0066C1.25641 11.8199 2.36997 12.9339 3.18375 12.185C3.18375 12.185 3.72896 11.6397 3.81242 11.5563C4.13759 11.2317 4.13759 10.703 3.81242 10.3779Z"
      fill="currentColor"
    />
    <path
      d="M7.51285 14.7188C7.29021 14.7188 7.08082 14.8056 6.92341 14.963L6.29474 15.5916C6.2918 15.5946 6.28886 15.5975 6.28591 15.601C5.97089 15.9122 5.9756 16.4633 6.29474 16.77C6.61986 17.0947 7.14849 17.0947 7.47313 16.77L8.10228 16.1409C8.62336 15.6211 8.24881 14.716 7.51285 14.7188Z"
      fill="currentColor"
    />
    <path
      d="M13.1039 5.47076C11.8177 6.28184 10.093 6.12787 8.97345 5.00833L7.51604 3.5514L9.33486 1.73258C7.38133 -0.459664 3.94622 -0.598736 1.86681 1.4948C-0.223884 3.57127 -0.0898628 7.00231 2.09777 8.95643C3.69092 8.066 5.65004 9.3097 5.52112 11.1239C6.57603 11.2379 7.46911 12.1941 7.51746 13.2492C8.50945 13.228 9.49483 13.9709 9.73644 14.9508C10.5623 14.7295 11.4879 15.0037 12.0535 15.658L12.0702 15.6384C12.8901 16.1307 13.7576 15.1195 13.1392 14.383L13.1407 14.381C13.1279 14.3688 9.82912 11.07 9.82912 11.07C10.0883 10.8108 10.61 10.289 10.8692 10.0299L14.143 13.3037C14.9563 14.053 16.0705 12.9387 15.3209 12.1253L12.0476 8.85149C12.3068 8.59227 12.8285 8.07056 13.0877 7.81139C13.8235 8.54711 15.6085 10.3322 16.3615 11.0852C16.6715 11.4081 17.2298 11.408 17.5399 11.0852C17.8645 10.7601 17.8645 10.2314 17.5399 9.90679L13.1039 5.47076Z"
      fill="currentColor"
    />
    <path
      d="M18.8833 1.49468C16.8899 -0.498227 13.6465 -0.498227 11.6531 1.49468C11.2655 1.88252 9.96299 3.18532 9.59692 3.55134L10.0137 3.96816C10.7385 4.69294 11.9174 4.69294 12.6417 3.96816L13.162 3.44787C13.4386 3.72753 18.5165 8.79669 18.6592 8.94945C20.8416 6.9946 20.9709 3.56845 18.8833 1.49468Z"
      fill="currentColor"
    />
    <path
      d="M10.9122 16.5898C10.587 16.2652 10.0588 16.2648 9.73379 16.5898L9.10512 17.2185C8.78162 17.5286 8.78176 18.0867 9.10512 18.3969C9.41568 18.7197 9.97314 18.7195 10.2835 18.3969L10.9122 17.7682C11.235 17.4585 11.235 16.8988 10.9122 16.5898Z"
      fill="currentColor"
    />
  </svg>
</template>